import { Phone, X } from "lucide-react";
import { useState } from "react";

const FloatingPhone = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 hidden md:flex flex-col items-end gap-3 md:bottom-8 md:right-8">
      {open && (
        <div className="bg-card border border-accent/30 shadow-lg px-5 py-4 max-w-xs text-right animate-fade-in">
          <button
            onClick={() => setOpen(false)}
            className="absolute top-2 right-2 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Schließen"
          >
            <X className="w-4 h-4" />
          </button>
          <p className="text-sm text-muted-foreground mb-2 pr-4">
            Sie haben Fragen? Rufen Sie uns gerne an:
          </p>
          <a
            href="tel:+4921224355830"
            className="inline-flex items-center gap-2 text-accent font-medium text-base hover:text-foreground transition-colors"
          >
            <Phone className="w-5 h-5" />
            0212 24355830
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center justify-center w-14 h-14 bg-accent text-white shadow-lg hover:bg-accent/90 transition-colors rounded-full"
        aria-label="Telefonnummer anzeigen"
      >
        <Phone className="w-6 h-6" />
      </button>
    </div>
  );
};

export default FloatingPhone;
